import Container from '@mui/material/Container';
import { useEffect } from 'react';
import { PosLayout } from '../../features/POS';
import { WhoHelped } from '../../features/POS/components';
import { useAppDispatch, useAppSelector } from '../../hooks/useAppStore';
import { getAuthenticateUser } from '../../store/authenticate/selectors';
import { authActions } from '../../store/authenticate/slice';
import { PAGES_ANALYTICS_TITLES } from '../../utils/enums';
import { PageHelmet } from '../../components';

const AttributeStaff = () => {
  const dispatch = useAppDispatch();
  const authenticateUser = useAppSelector(getAuthenticateUser);
  useEffect(() => {
    dispatch(authActions.setAuthenticateUser({
      ...authenticateUser,
      user: {
        ...authenticateUser.user,
        settings: {
          ui: {
            theme: 'dark',
            locale: 'en',
          },
        },
      },
    }));
  }, []);

  return (
    <PageHelmet title={PAGES_ANALYTICS_TITLES.ATTRIBUTE}>
      <Container
        sx={{
          pt: 12,
        }}
        maxWidth={false}
      >
        <PosLayout />
        <WhoHelped />
      </Container>
    </PageHelmet>
  );
};

export {
  AttributeStaff,
};
